/**
 * Helpers para classificação de categorias de despesas.
 * Não depende de ilike - usa regra local robusta.
 */

export function isTireCategory(cat?: string | null): boolean {
  const c = (cat ?? "").toLowerCase();
  return ["pneu", "pneus", "tire", "tires", "borracharia", "rodas"].some((k) => c.includes(k));
}

/**
 * Normaliza uma "categoria de despesa" para evitar UI inconsistente.
 * Se você tiver category_code no banco, use ele como prioridade.
 */
export function normalizeExpenseCategory(input?: string | null): string {
  const c = (input ?? "").trim();
  if (!c) return "Outros";
  return c.charAt(0).toUpperCase() + c.slice(1);
}
